module.exports = __webpack_public_path__ + "static/media/producttabsimg.1de45a1b.png";